import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { environment } from '../../../environments/environment';

export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);

  // Only intercept requests to our external API
  if (!req.url.includes(environment.externalApiUrl)) {
    return next(req);
  }

  const headers: Record<string, string> = {};

  // Always send the access key (public, identifies tenant)
  if (environment.apiAccessKey) {
    headers['X-API-Key'] = environment.apiAccessKey;
  }

  // Only send the secret key on the server side (SSR) — never in the browser
  if (isPlatformServer(platformId) && environment.apiSecretKey) {
    headers['X-API-Secret'] = environment.apiSecretKey;
  }

  const cloned = req.clone({ setHeaders: headers });
  return next(cloned);
};
